import React, { useCallback, useEffect } from 'react';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { useDeleteLibraryAcademyTopicMutation } from 'features/classCreation';

function DeleteLibraryClass({ cls }) {
  const [deleteTemplate, { error, isLoading: isDeleting }] =
    useDeleteLibraryAcademyTopicMutation();

  const handleConfirmation = useCallback(() => {
    const canProceed = window.confirm(
      'Are you sure, proceeding will remove this class from the library?'
    );

    if (canProceed) {
      deleteTemplate({ id: cls.id, libraryId: cls.library_id });
    }
  }, [cls.id, cls.library_id, deleteTemplate]);

  useEffect(() => {
    if (error) {
      const message =
        error.data?.message ||
        'Failed to remove class, please try again after sometime!';
      cogoToast.error(message);
    }
  }, [error]);

  return (
    <Tappable
      className="btn btn-primary btn-inverted btn-icon btn-small"
      disabled={isDeleting}
      onClick={handleConfirmation}
    >
      <Icon
        className="cursor"
        name="trash"
      />
    </Tappable>
  );
}

export default DeleteLibraryClass;
